export function getExtraProductsRenderFlags({ baggagesExtrasOnly, flexTicket, insurance, geniusFlexTicket, cabinBaggagePerTraveller, checkedInBaggage, inconsistentCabinBaggageInfo }) {
    const canRenderFlexibility = !baggagesExtrasOnly && (!!flexTicket || !!insurance || !!geniusFlexTicket);
    const canRenderBaggages = !!baggagesExtrasOnly && (!!cabinBaggagePerTraveller || !!checkedInBaggage);
    const legacyHasContent = !!(inconsistentCabinBaggageInfo ||
        cabinBaggagePerTraveller ||
        checkedInBaggage ||
        flexTicket ||
        insurance);
    return { canRenderFlexibility, canRenderBaggages, legacyHasContent };
}
